module.exports = __webpack_public_path__ + "static/media/26.c894e364.png";